module.exports = __webpack_public_path__ + "static/img/04.49d5d31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/04.jpg
// module id = y7Hl
// module chunks = 1